import React, { useState, useCallback } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Header, CBContainer } from './styled';
import Checkbox from '../checkbox';
import { CHECKED, UNCHECKED, INDETERMINATE } from '../checkbox/constants';
import { GRID_CELL_SELECTION } from '../../containers/course-assign/course-assign-types';

const GridHeader = (props) => {
  const dispatch = useDispatch();
  const [checkboxState, setCheckboxState] = useState(UNCHECKED);
  const { activities, mappedAssignmentIndexes } = props;

  function handleOnClick(activity, cbStatus) {
    setCheckboxState(cbStatus);
    dispatch({
      type: GRID_CELL_SELECTION,
      indexes: mappedAssignmentIndexes?.[activity.activityName],
      status: cbStatus
    });
  }

  const getState = (filteredActivities = []) => {
    let state = checkboxState;
    const selectedCells = filteredActivities.filter(
      ({ isSelected }) => isSelected
    );
    if (!selectedCells.length && !filteredActivities.length) state = UNCHECKED;
    if (selectedCells.length >= filteredActivities.length) {
      state = CHECKED;
    }
    if (
      selectedCells.length > 0 &&
      selectedCells.length < filteredActivities.length
    ) {
      state = INDETERMINATE;
    }
    if (selectedCells.length === 0) state = UNCHECKED;

    return state;
  };

  function HeaderCheckboxes({ activity, indexes }) {
    const studentAssignments = useSelector(
      (state) =>
        indexes.map(
          (x) => state.CourseAssignReducer.assignments.studentAssignments[x]
        ),
      shallowEqual
    );
    return (
      <CBContainer>
        <Checkbox
          checkboxHandler={(cbStatus) => handleOnClick(activity, cbStatus)}
          state={getState(studentAssignments)}
        />
      </CBContainer>
    );
  }
  HeaderCheckboxes.propTypes = {
    activity: PropTypes.object.isRequired,
    indexes: PropTypes.arrayOf(PropTypes.number).isRequired
  };

  const displayCheckboxes = useCallback(
    () =>
      activities.map((activity) => (
        <HeaderCheckboxes
          activity={activity}
          // eslint-disable-next-line react/prop-types
          key={`${activity.activityId}_${activity.activityName}`}
          indexes={
            // eslint-disable-next-line react/prop-types
            mappedAssignmentIndexes?.[activity.activityName] || []
          }
        />
      )),
    [activities, mappedAssignmentIndexes]
  );
  return <Header>{displayCheckboxes()}</Header>;
};

GridHeader.propTypes = {
  activities: PropTypes.array.isRequired,
  mappedAssignmentIndexes: PropTypes.object.isRequired
};

GridHeader.defaultProps = {
  activityIds: []
};

export default GridHeader;



// WEBPACK FOOTER //
// ./components/grid/grid-header.js